import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import collab from "../../assets/icons/immersiveNew/CollaborativeArtboard.svg"
import cost from "../../assets/icons/immersiveNew/Cost-EffectiveArtboard.svg"
import proven from "../../assets/icons/immersiveNew/ProvenExpertise.svg"
import scale from "../../assets/icons/immersiveNew/ScalableArtboard.svg"
import tailored from "../../assets/icons/immersiveNew/TailoredArtboard.svg"
import fullSupport from "../../assets/icons/immersiveNew/FullArtboard.svg"
const WhyTalk = () => {
  const features = [
    { icon: collab, title: "Collaborative", desc: "We work alongside you to deliver what’s needed." },
    { icon: cost, title: "Cost-Effective", desc: "Get the most out of your current investment with strategic upgrades." },
    { icon: proven, title: "Proven Expertise", desc: "Leaders in healthcare training and immersive technology." },
    { icon: scale, title: "Scalable Growth", desc: "Future-proof your immersive technology for years to come." },
    { icon:tailored, title: "Tailored Solutions", desc: "Custom content and upgrades to meet your needs." },
    { icon: fullSupport, title: "Full Support", desc: "We’re with you all the way, ready to fix any issues as they arise." },
  ];

  return (
    <div className="why-talk-section">
      <Container>
        <h2 className="mxr__section-title text-uppercase">Why talk to Simulation Collective ?</h2>
        <Row>
          {features.map((item, index) => (
            <Col md={6} key={index} className="why-talk-item">
              <div className="icon">
                <img src={item.icon} alt={item.title} />
                </div>
              <div>
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default WhyTalk;
